import {gql} from "apollo-angular";
import {institutionServiceFields} from "../service/service.graphql";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const GET_INSTITUTION_SUB_SERVICES = gql`
  query GetInstitutionSubServices($serviceUniqueId: String) {
    getInstitutionSubServices(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

